import * as React from 'react'

import DetermineFieldType from './DetermineFieldType'
import * as Styled from './Form.styles'

const FormFields = ({
  className = null,
  fields = [],
  nextStep = null,
  inlineButton = false,
  submitButton = null,
  radioFieldsAsButtons = false,
  additional = null,
  smartyStreetsWebsiteKey = true,
}) => (
  <Styled.FormTemplate className={className}>
    {fields?.length > 0 &&
      fields.map((field) => (
        <DetermineFieldType
          key={field.name}
          field={field}
          inlineButton={inlineButton}
          submitButton={submitButton}
          nextStep={nextStep}
          radioFieldsAsButtons={radioFieldsAsButtons}
          smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
        />
      ))}
    {additional && additional}
  </Styled.FormTemplate>
)

export default FormFields
